import { DeviceType } from '@yanolja-rnd/nol-design-system/dist/types/device.types'
import { UAParser } from 'ua-parser-js'

export function copy(o) {
  if (typeof o === 'object') {
    return JSON.parse(JSON.stringify(o))
  }
  return o
}

export function traverse(this: any, o, fn) {
  for (const i in o) {
    if (typeof o[i] === 'object') {
      traverse(o[i], fn)
    } else {
      o[i] = fn.call(this, o[i], i)
    }
  }
}

export const mask = val => {
  if (typeof val === 'string') {
    if (val.length <= 1) {
      return val
    }
    return '*'.repeat(val.length - 1) + val.substr(val.length - 1, 1)
  }
  if (typeof val === 'number') {
    return 0
  }
  return val
}

export const isTruth = (v: any) => ['true', 1, '1', 'TRUE', 'True'].includes(v)

export enum MobileOS {
  WindowsPhone = 'WindowsPhone',
  Android = 'Android',
  iOS = 'iOS',
}

// https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
export function getMobileOperatingSystem(userAgent: string): MobileOS | null {
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return MobileOS.WindowsPhone
  }

  if (/android/i.test(userAgent)) {
    return MobileOS.Android
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return MobileOS.iOS
  }
  return null
}

/**
 * NOL API headers 정보에 필요한 device platform 정보
 */
export function getNolPlatformFromUserAgent(userAgent?: string) {
  const ua = new UAParser(userAgent).getResult()

  // App OS 여부
  const isApp = ['Android', 'iOS'].includes(ua.os.name || '')

  // 모바일 기기(휴대폰, 태블릿) 여부
  const isMobileDevice = ua.device.type === 'mobile' || ua.device.type === 'tablet'
  return isApp ? ua.os.name : isMobileDevice ? 'MWeb' : 'Web'
}

/**
 * userAgent를 기반으로 DeviceType을 반환하는 함수
 * @param userAgent - 브라우저의 userAgent 문자열
 * @returns DeviceType - ios | android | etc
 */
export function getDeviceTypeFromUserAgent(userAgent?: string): DeviceType {
  const ua = new UAParser(userAgent).getResult()
  if (ua.os.name === 'iOS') return 'ios'
  if (ua.os.name === 'Android') return 'android'
  return 'etc'
}
